var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecuritySettingIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2672 2.5113C8.09687 2.43677 7.90313 2.43677 7.7328 2.5113L3.73279 4.2613C3.49013 4.36746 3.33333 4.6072 3.33333 4.87207V8.66672C3.33333 9.80912 3.74381 10.8556 4.4253 11.6668C5.28091 10.6483 6.56431 10 7.99993 10C9.4356 10 10.719 10.6483 11.5746 11.6668C12.2562 10.8556 12.6667 9.80912 12.6667 8.66672V4.87207C12.6667 4.6072 12.5099 4.36746 12.2672 4.2613L8.2672 2.5113ZM10.5801 12.5559C9.96833 11.809 9.03927 11.3334 7.99993 11.3334C6.96067 11.3334 6.03161 11.809 5.41986 12.5558C6.15891 13.0471 7.046 13.3334 8 13.3334C8.95393 13.3334 9.841 13.0472 10.5801 12.5559ZM7.19833 1.28976C7.7094 1.06618 8.2906 1.06618 8.80167 1.28976L12.8017 3.03976C13.5296 3.35824 14 4.07748 14 4.87207V8.66672C14 11.9804 11.3137 14.6667 8 14.6667C4.68629 14.6667 2 11.9804 2 8.66672V4.87207C2 4.07748 2.47039 3.35824 3.19836 3.03976L7.19833 1.28976ZM8 5.66672C7.35567 5.66672 6.83333 6.18905 6.83333 6.83338C6.83333 7.47772 7.35567 8.00005 8 8.00005C8.64433 8.00005 9.16667 7.47772 9.16667 6.83338C9.16667 6.18905 8.64433 5.66672 8 5.66672ZM5.5 6.83338C5.5 5.45267 6.61929 4.33338 8 4.33338C9.38073 4.33338 10.5 5.45267 10.5 6.83338C10.5 8.21412 9.38073 9.33338 8 9.33338C6.61929 9.33338 5.5 8.21412 5.5 6.83338Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuritySettingIcon);
export default __webpack_public_path__ + "static/media/SecuritySettingIcon.5663a2a872fd841ee99c134acdbe0707.svg";
export { ForwardRef as ReactComponent };